import { GET_BEE_AUTH_TOKEN_URL } from 'api/TemplateEditAPI';
import { UseRestPostQueryQueryOptions, useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import { AuthToken } from '../types';

type QueryBeeAuthTokenRequest = undefined;
type QueryBeeAuthTokenResponse = AuthToken;

export const useQueryBeeAuthToken = (
  usePopupBuilder?: boolean,
  options?: UseRestPostQueryQueryOptions<QueryBeeAuthTokenResponse>,
) => {
  const queryOptions: UseRestPostQueryQueryOptions<QueryBeeAuthTokenResponse> = {
    ...options,
    enabled: false, // Don't auto fetch, only trigger when `refetch` is called.
    /**
     * these were disabled to keep feature working as before when this request was migrated to react-query
     * @see https://tanstack.com/query/v4/docs/react/guides/important-defaults
     */
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  };

  const params = usePopupBuilder ? `?usePopupBuilder=${usePopupBuilder}` : '';

  const { isLoading, error, data, refetch } = useRestPostQuery<
    QueryBeeAuthTokenResponse,
    QueryBeeAuthTokenRequest
  >(`${GET_BEE_AUTH_TOKEN_URL}${params}`, undefined, queryOptions);

  return {
    isLoading,
    error,
    token: data,
    getBeeAuthToken: refetch,
  };
};
